import { render } from "./GroupUtm.vue?vue&type=template&id=6faf972c"
import script from "./GroupUtm.vue?vue&type=script&lang=js"
export * from "./GroupUtm.vue?vue&type=script&lang=js"

import "./GroupUtm.vue?vue&type=style&index=0&id=6faf972c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__